import { decorateEditorialHtml } from "../../../../ContentUtilities";
import * as React from "react";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { UitkPrimaryButton } from "uitk-react-button";
import { formatText } from "bernie-l10n";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export const CitiCardModalDialogPopUp = (props: { items: EditorialModel[] }) => {
  const CONTENT_ID_COUNT = 8;
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [
    chooseCardText,
    feeCardImage,
    feeCardSubText,
    feeCardOfferText,
    seperator,
    noFeeCardImage,
    noFeeCardSubText,
    noFeeCardOfferText,
  ] = items.map((item) => decorateEditorialHtml(item.text));
  const applyNowText = formatText("grid3.citiDesktopStickybar.applyNow.text");

  return (
    <UitkLayoutGrid rows={1} space="six">
      <UitkLayoutGridItem>
        <div className="uitk-type-center">
          <UitkText align="center" size={600} weight="bold">
            <div dangerouslySetInnerHTML={chooseCardText} />
          </UitkText>
        </div>
      </UitkLayoutGridItem>
      <UitkLayoutGridItem>
        <div>
          <div className="uitk-type-center all-b-padding-three">
            <div dangerouslySetInnerHTML={feeCardImage} />
          </div>
          <UitkText align="center" size={300} weight="bold">
            <div dangerouslySetInnerHTML={feeCardSubText} />
          </UitkText>
          <UitkText align="center" size={200} weight="bold" className="all-b-padding-three">
            <div dangerouslySetInnerHTML={feeCardOfferText} />
          </UitkText>
          <div className="uitk-type-center">
            <UitkPrimaryButton type="button" text={applyNowText} />
          </div>
        </div>
      </UitkLayoutGridItem>

      <UitkLayoutGridItem>
        <div className="uitk-type-center">
          <div dangerouslySetInnerHTML={seperator} />
        </div>
      </UitkLayoutGridItem>

      <UitkLayoutGridItem>
        <div>
          <div className="uitk-type-center all-b-padding-three">
            <div dangerouslySetInnerHTML={noFeeCardImage} />
          </div>
          <UitkText align="center" size={300} weight="bold">
            <div dangerouslySetInnerHTML={noFeeCardSubText} />
          </UitkText>
          <UitkText align="center" size={200} weight="bold" className="all-b-padding-three">
            <div dangerouslySetInnerHTML={noFeeCardOfferText} />
          </UitkText>
          <div className="uitk-type-center">
            <UitkPrimaryButton type="button" text={applyNowText} />
          </div>
        </div>
      </UitkLayoutGridItem>
    </UitkLayoutGrid>
  );
};
export default CitiCardModalDialogPopUp;
